/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacetValue } from './FacetValue';
import {
    FacetValueFromJSON,
    FacetValueFromJSONTyped,
    FacetValueToJSON,
} from './FacetValue';

/**
 * Representation of a Facet
 * @export
 * @interface Facet
 */
export interface Facet {
    /**
     * Name of the facet
     * @type {string}
     * @memberof Facet
     */
    name?: string;
    /**
     * Priority value of the facet
     * @type {number}
     * @memberof Facet
     */
    priority?: number;
    /**
     * Flag stating if facet is category facet
     * @type {boolean}
     * @memberof Facet
     */
    category?: boolean;
    /**
     * Flag stating if facet is multiSelect
     * @type {boolean}
     * @memberof Facet
     */
    multiSelect?: boolean;
    /**
     * Flag stating if facet is visible
     * @type {boolean}
     * @memberof Facet
     */
    visible?: boolean;
    /**
     * List of top facet values
     * @type {Array<FacetValue>}
     * @memberof Facet
     */
    topValues?: Array<FacetValue>;
    /**
     * List of all facet values
     * @type {Array<FacetValue>}
     * @memberof Facet
     */
    values?: Array<FacetValue>;
}

/**
 * Check if a given object implements the Facet interface.
 */
export function instanceOfFacet(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FacetFromJSON(json: any): Facet {
    return FacetFromJSONTyped(json, false);
}

export function FacetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Facet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'multiSelect': !exists(json, 'multiSelect') ? undefined : json['multiSelect'],
        'visible': !exists(json, 'visible') ? undefined : json['visible'],
        'topValues': !exists(json, 'topValues') ? undefined : ((json['topValues'] as Array<any>).map(FacetValueFromJSON)),
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(FacetValueFromJSON)),
    };
}

export function FacetToJSON(value?: Facet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'priority': value.priority,
        'category': value.category,
        'multiSelect': value.multiSelect,
        'visible': value.visible,
        'topValues': value.topValues === undefined ? undefined : ((value.topValues as Array<any>).map(FacetValueToJSON)),
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(FacetValueToJSON)),
    };
}

